import { render, staticRenderFns } from "./tab-configurar.vue?vue&type=template&id=3dc08d04&"
import script from "./tab-configurar.vue?vue&type=script&lang=js&"
export * from "./tab-configurar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports